module.exports = __webpack_public_path__ + "static/media/FM_EU_Company_Information_March_2025.131d1a3b.pdf";